import { useMemo } from "react";
import { Raster } from "../../../generated/graphql";
import RasterLayer from "../layers/raster";
import { LayerConfig, LayerHook, LayerHookBuilder } from "./types";

export type RasterLayerConfig = LayerConfig & { rasters: Array<Raster> };

const useRasterHook: LayerHookBuilder<RasterLayerConfig> = ({ config }) => {
  return useMemo<LayerHook>(() => {
    return {
      render: () => {
        return config.rasters.map(raster => (
          <RasterLayer rasterId={raster.id} key={raster.id} />
        ));
      },
    };
  }, [config]);
};

export default useRasterHook;
